import { Theme } from "@/types/__gql__"

export const predictionStatusColorMap = {
  LONGLISTED: "#0b30d6",
  SHORTLISTED: "#ff9933",
  DECLINED: "#fc5050",
  NA: "#939eab",
  HIRED: "#7ed321",
  NEW: "#4da1ff",
  Total: ""
}

//policy links
export const privacyPolicyLink = "https://me.predictivehire.com/candidate-explainer-privacy-policy/"
export const usePolicyLink = "https://me.predictivehire.com/acceptable-use-policy"
export const cookiePolicyLink = "https://me.predictivehire.com/cookie-policy"

// unit ms
export const searchDebounce = { wait: 1000 }

//report link in side menu
export const discoverInsightsLink =
  "https://eu-west-1.quicksight.aws.amazon.com/sn/dashboards/6ef2d154-a005-4c7e-aa85-43e3bf2ed163?directory_alias=predictivehire-insights"

export const defaultBackgroundColor = "#2d38ff"
export const defaultLightFontColor = "#ffffff"
export const defaultDarkFontColor = "#222222"
export const defaultHIntBGColor = "#add8e6"

export const defaultTheme: Theme = {
  header: {
    backgroundColor: defaultBackgroundColor,
    fontColor: defaultLightFontColor
  },
  progressBar: {
    backgroundColor: "#bbbfff",
    fontColor: defaultHIntBGColor
  },
  hint: {
    backgroundColor: defaultHIntBGColor,
    fontColor: defaultDarkFontColor
  },
  question: {
    backgroundColor: "#f3f5f5",
    fontColor: defaultDarkFontColor
  },
  response: {
    backgroundColor: defaultHIntBGColor,
    fontColor: defaultLightFontColor
  },
  listItem: {
    backgroundColor: "#ffffff",
    fontColor: "#000000de"
  },
  selectedItem: {
    backgroundColor: defaultBackgroundColor,
    fontColor: defaultLightFontColor
  },
  button: {
    backgroundColor: defaultBackgroundColor,
    fontColor: defaultLightFontColor
  }
}
